export const LAUNCH_DATE = new Date("2026-11-01T00:00:00+01:00");

export const COVER_IMAGE = "/assets/copertina.jpg";

export const IMAGES = {
  hero: "/assets/lago-nebbia.jpg",
  mondoBg: "/assets/lago-riva.jpg",
};

export const RETAILERS = [
  { id: "hever", name: "Hever Edizioni — Ordine online", url: "https://www.hever.it/i-nostri-libri/il-segreto-del-lago/" },
  { id: "librerie", name: "Librerie in tutta Italia — come ordinare", url: "https://www.hever.it/dove-acquistare/" },
];

export const HOTSPOTS = [
  {
    id: "san-giulio",
    name: "Isola di San Giulio",
    x: 50,
    y: 52,
    desc: "La culla della leggenda. Qui, nel IV secolo, San Giulio compì la sua ultima impresa: attraversò le acque sul proprio mantello e fondò la basilica sull'isola infestata dai serpenti. Nella sagrestia della basilica è sospeso un grande osso che la tradizione chiama vertebra del drago — molto probabilmente un reperto fossile di cetaceo — visitabile ancora oggi.",
    lore: "Nel romanzo, sotto l'isola il drago custodisce da sedici secoli il segreto del Santo: una pietra magica dal potere immenso. Ed è qui che, nel Seicento, si consuma la tragedia di Elisabetta e Lorenzo.",
    fotos: ["/assets/isola-1.jpg", "/assets/isola-2.jpg", "/assets/isola-3.jpg", "/assets/isola-4.jpg"],
  },
  {
    id: "orta",
    name: "Borgo di Orta San Giulio",
    x: 67,
    y: 60,
    desc: "Vicoli in pietra serena, palazzi affrescati, la piazzetta sul molo e i glicini. Il cuore antico della Riviera.",
    lore: "Su queste rive lo spirito di Elisabetta attende da tre secoli. Ed è qui che, nel 2025, Marco riemerge dalle acque.",
    fotos: ["/assets/orta-piazza.jpg", "/assets/orta-imbarcadero.jpg"],
  },
  {
    id: "omegna",
    name: "Omegna e il Nord del Lago",
    x: 48,
    y: 9,
    desc: "All'estremità settentrionale, dove il lago diventa fiume Nigoglia: l'unico emissario d'Italia che scorre verso nord.",
    lore: "Nel romanzo, l'acqua che scorre controcorrente è il primo indizio che qualcosa, nel lago, si è risvegliato.",
    fotos: ["/assets/omegna-lungolago.jpg"],
    fotoCredit: "Foto: Fabio Poggi · Wikimedia Commons · CC BY 3.0",
  },
  {
    id: "chiesetta",
    name: "Chiesetta di San Giulio — sponda ovest",
    x: 31,
    y: 47,
    desc: "Sulla sponda occidentale del lago, immersa nel verde di fronte all'isola, la chiesetta dedicata al Santo custodisce una sorgente d'acqua che scorre ancora oggi.",
    lore: "È qui, vicino alla chiesetta e alla sua sorgente, che la pietra magica viene ritrovata: il segreto di San Giulio torna alla luce.",
    fotos: ["/assets/chiesetta-san-giulio.jpg"],
  },
  {
    id: "gozzano",
    name: "Gozzano",
    x: 52,
    y: 91,
    desc: "Borgo all'estremità meridionale del lago, affacciato sul golfo tra colline e acque tranquille.",
    lore: "Qui San Giuliano, il fratello costruttore, edificò la sua novantanovesima chiesa: l'ultima prima dell'impresa finale di Giulio sull'isola.",
    fotos: ["/assets/gozzano-san-giuliano.jpg"],
    fotoCredit: "Foto: Alessandro Vecchi · Wikimedia Commons · CC BY-SA 3.0",
  },
  {
    id: "pettenasco",
    name: "Pettenasco",
    x: 62,
    y: 30,
    desc: "A bordo lago sulla sponda orientale, tra giardini d'ulivo e gli storici cantieri delle barche in legno. In paese veglia la chiesa dei Santi Audenzio e Caterina.",
    lore: "Qui aveva la sua villa il senatore Audenzio — proprio come il santo cui è dedicata la chiesa del paese: una presenza che, nel romanzo, non è soltanto uno sfondo.",
    fotos: ["/assets/pettenasco-audenzio.jpg"],
    fotoCredit: "Foto: Explore.piedmont · Wikimedia Commons · CC BY-SA 4.0",
  },
  {
    id: "prarolo",
    name: "Spiaggia di Prarolo — San Maurizio d'Opaglio",
    x: 35,
    y: 33,
    desc: "Una spiaggia a bordo lago nel comune di San Maurizio d'Opaglio, sulla sponda nord-occidentale.",
    lore: "È dalla spiaggia di Prarolo che Marco, nel 1989, entra nelle acque del lago per non tornare. Almeno fino al 2025.",
    fotos: ["/assets/spiaggia-prarolo.jpg"],
  },
  {
    id: "boec-orchera",
    name: "Böc del'Orchera — il Buco del Drago",
    x: 70,
    y: 67,
    desc: "In una casa privata poco fuori Orta si apre il Böc del'Orchera, il «buco del drago»: una voragine nella roccia con il suo antico pozzo in ferro battuto, che la tradizione lega alle profondità del lago. Si visita solo occasionalmente, in giornate speciali.",
    lore: "Nel romanzo è una delle vie verso il regno del drago: chi si china sul pozzo giura di sentire l'acqua respirare.",
    fotos: ["/assets/boec-orchera.jpg"],
    fotoPos: "center 65%",
  },
  {
    id: "lagna",
    name: "Lagna — San Maurizio d'Opaglio",
    x: 37,
    y: 21,
    desc: "Frazione di San Maurizio d'Opaglio, a bordo lago: tetti, orti e barche affacciati direttamente sulle acque, e l'antico lavatoio dove l'acqua non ha mai smesso di scorrere.",
    lore: "A Lagna viveva Elisabetta, prima del matrimonio combinato e della fuga con Lorenzo: da qui si vede l'isola, e il suo destino.",
    fotos: ["/assets/lagna-lavatoio.jpg"],
    fotoPos: "center 82%",
  },
];

export const CHARACTERS = [
  {
    id: "san-giulio",
    numeral: "I",
    icon: "church",
    name: "San Giulio",
    role: "Il Santo delle Acque",
    faction: "IV Secolo · La Missione",
    description: "Sacerdote ortodosso fuggito dall'isola di Egina con il fratello Giuliano, perseguitato per la sua fede. Attraversò l'Italia fondando chiese, e sul Lago d'Orta compì la sua impresa finale — affidando al drago una pietra dal potere immenso.",
    testid: "character-card-san-giulio",
  },
  {
    id: "teodosio",
    numeral: "II",
    icon: "landmark",
    name: "Teodosio I",
    role: "L'Imperatore che Ascoltò",
    faction: "IV Secolo · Costantinopoli",
    description: "Imperatore romano d'Oriente. Ricevette a Costantinopoli i due fratelli fuggiti da Egina e, colpito dalla loro supplica, concesse loro il permesso di costruire chiese cristiane. Da quell'incontro cominciò tutto.",
    testid: "character-card-teodosio",
  },
  {
    id: "audenzio",
    numeral: "III",
    icon: "coins",
    name: "Audenzio",
    role: "Il Senatore Generoso",
    faction: "IV Secolo · Roma",
    description: "Senatore romano, cristiano della prima ora. Incontrò Giulio e Giuliano a Roma e, conquistato dalla loro fede e dalla loro missione, li sostenne con generosità nella costruzione delle chiese.",
    testid: "character-card-audenzio",
  },
  {
    id: "drago",
    numeral: "IV",
    icon: "flame",
    name: "Il Drago del Lago",
    role: "La Creatura Custode",
    faction: "Leggenda Profonda",
    description: "Creatura antica e saggia: non fu uccisa, divenne custode. Un incantesimo la volse contro gli amanti del Seicento; da sedici secoli veglia sulla pietra di San Giulio nelle profondità sotto l'isola.",
    testid: "character-card-dragon",
  },
  {
    id: "elisabetta",
    numeral: "V",
    icon: "heart",
    name: "Elisabetta",
    role: "La Ribelle del 1600",
    faction: "Amore Spezzato",
    description: "Promessa a un matrimonio combinato, scelse l'amore per il pescatore Lorenzo e pagò la sua ribellione con la reclusione. Il suo spirito non ha mai lasciato le rive del lago.",
    testid: "character-card-elisabetta",
  },
  {
    id: "elvira",
    numeral: "VI",
    icon: "moon",
    name: "Donna Elvira",
    role: "La Strega del Lago",
    faction: "L'Ombra del Seicento",
    description: "Madre di Adalberto e signora delle arti oscure. Con la magia nera manipolò i destini di Elisabetta e Lorenzo, scatenò il drago contro i due amanti e gettò la maledizione sulle acque.",
    testid: "character-card-witch",
  },
  {
    id: "marco",
    numeral: "VII",
    icon: "anchor",
    name: "Marco",
    role: "Il Ragazzo del 1989",
    faction: "Rinato dal Fondo",
    description: "Tradito dalla fidanzata e dal migliore amico, scelse le acque del lago per sparire. Nel 2025 un fulmine lo risveglia: creatura di metallo e fango, con la sua coscienza intatta.",
    testid: "character-card-marco",
  },
  {
    id: "adele-matilde",
    numeral: "VIII",
    icon: "flask",
    name: "Adele & Matilde",
    role: "Le Alleate del 2025",
    faction: "Bontà e Scienza",
    description: "Un'anziana signora dalla bontà infinita e sua figlia, scienziata del CERN. Saranno loro ad accogliere Marco e a decifrare il mistero della sua resurrezione.",
    testid: "character-card-lovers",
  },
  {
    id: "lago",
    numeral: "IX",
    icon: "waves",
    name: "Il Lago d'Orta",
    role: "Il Testimone Silente",
    faction: "Tutte le Epoche",
    description: "Non uno sfondo: un personaggio. Custode di sedici secoli di segreti, le sue acque accolgono, nascondono e restituiscono — teatro di miracoli, maledizioni e rinascite.",
    testid: "character-card-lago",
  },
];

export const EPOCHS = [
  { era: "IV Secolo", event: "La pietra di San Giulio" },
  { era: "1600", event: "La maledizione di donna Elvira" },
  { era: "1989", event: "La scomparsa di Marco" },
  { era: "2025", event: "Il risveglio" },
];

export const SAGA_BOOKS = [
  {
    volume: "Primo Romanzo",
    title: "Il Segreto del Lago",
    release: "Novembre 2026",
    status: "In Arrivo",
    active: true,
    synopsis: "Quattro epoche, un solo lago: la missione di San Giulio, la tragedia di Elisabetta e Lorenzo, la scomparsa di Marco e il risveglio che riaccenderà l'antico segreto.",
  },
  {
    volume: "Secondo Romanzo",
    title: "Titolo in arrivo",
    release: "2027",
    status: "In Scrittura",
    active: false,
    synopsis: "La storia continua. Le forze oscure del passato non hanno detto la loro ultima parola. Teaser in arrivo.",
  },
];

export const MEDIA_ITEMS = [
  {
    id: "landexplorer-content-tourism",
    type: "video",
    title: "Content tourism: come una storia diventa sviluppo territoriale",
    source: "Landexplorer · YouTube",
    url: "https://youtu.be/6gT3SRRvOHk",
    youtubeId: "6gT3SRRvOHk",
    note: "Si parla de Il Segreto del Lago e di come una storia possa diventare sviluppo per il territorio del Lago d'Orta.",
  },
];

export const PRESS_ITEMS = [
  { id: "trailer-vertical", title: "Booktrailer Verticale 9:16", format: "MP4 · TikTok, Reels, YouTube Shorts", url: "/assets/booktrailer-vertical.mp4", testid: "press-download-trailer-vertical" },
];

export const MARQUEE_ITEMS = [
  "Un amore oltre il tempo",
  "Lago d'Orta",
  "IV secolo · 1600 · 1989 · 2025",
  "L'Isola di San Giulio",
  "La pietra di San Giulio",
  "Il drago custode",
  "Novembre 2026",
  "Leggende vere, amore impossibile",
];

export const NAV_LINKS = [
  { label: "Il Libro", id: "libro" },
  { label: "Il Mondo", id: "mondo" },
  { label: "I Personaggi", id: "personaggi" },
  { label: "Quiz", id: "quiz" },
  { label: "La Saga", id: "saga" },
  { label: "Autrice", id: "autrice" },
  { label: "Eventi", id: "eventi" },
  { label: "Galleria", id: "galleria" },
  { label: "Blog", id: "blog" },
  { label: "Media", id: "media" },
  { label: "Press Kit", id: "press" },
];

export const SOCIALS = [
  { label: "Instagram", url: "https://instagram.com/ilsegretodellago_lasaga", handle: "@ilsegretodellago_lasaga", testid: "footer-social-instagram" },
  { label: "TikTok", url: "https://tiktok.com/@patriziafranzina", handle: "@patriziafranzina", testid: "footer-social-tiktok" },
  { label: "Facebook", url: "https://www.facebook.com/profile.php?id=61593949774526&locale=it_IT", handle: "pagina ufficiale", testid: "footer-social-facebook" },
  { label: "YouTube", url: "https://youtube.com/@patriziafranzina", handle: "@patriziafranzina", testid: "footer-social-youtube" },
];
